// File: Components/ui/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the main content container to top
    const mainContent = document.querySelector(".content");
    if (mainContent) {
      mainContent.scrollTo({ top: 0, behavior: "smooth" });
    }
    
    // Scroll the sidebar container to top
    const sidebar = document.querySelector(".sidebar");
    if (sidebar) {
      sidebar.scrollTo({ top: 0, behavior: "smooth" });
    }

    // Fallback: always scroll the window too
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
     